import styled from "styled-components"

import { when, eq, maxWidth } from "utils"

export const Button = styled.button`
  min-width: 19.2rem;
  padding: 1.5rem 1.7rem;
  border-radius: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  font-weight: 500;
  letter-spacing: 0.01rem;
  text-transform: uppercase;
  background-color: ${({ primary, theme }) =>
    primary ? theme.component.cta : theme.component.ctaSecondary};
  color: ${({ theme }) => theme.colors.text.alternate};

  ${({ theme }) =>
    theme.component.isDarkBackground &&
    `
      background-color: ${theme.component.ctaInverted};
      color: ${theme.colors.text.primary};
    `}

  ${when("notEnabled")`
    cursor: not-allowed;
  `}

  ${eq("buttonStyle", "Outline")`
    border: 0.1rem solid #979797;
    background: transparent;
    color: ${({ theme }) => theme.colors.text.primary};
  `}

  ${eq("size", "Small")`
    font-size: 1.5rem;
    padding: 1.2rem 2rem;
    letter-spacing: 0.094rem;
  `}

  ${eq("size", "Large")`
    font-size: 1.6rem;
    padding: 2rem 2rem;
    letter-spacing: 0.2rem;
    `}

${eq("size", "Extra Large")`
    padding: 2rem 2rem;
    font-size: 2rem;
    letter-spacing: 0.1rem;
  `}

  ${eq("buttonStyle", "Text Link")`
    min-width: unset;
    margin-left: 2.5rem;
    padding: 0;
    border: none;
    text-decoration: underline;
    background: transparent;
    color: ${({ theme, primary }) =>
      theme.component.isDarkBackground
        ? theme.component.ctaInverted
        : primary
        ? theme.component.cta
        : theme.component.ctaSecondary};

    ${when("hasNavigation")`
      color: #12233F;
      font-size: 2rem;
      font-weight: 500;
      line-height: 1.35rem;
      letter-spacing: 0.01rem;
      text-decoration: none;
      margin: 0;
      min-width: fit-content;

      ${maxWidth.tablet`
        font-size: 1rem;
        line-height: 1.35rem;
        letter-spacing: 0.01rem;
        text-transform: uppercase;
      `}
    `}
  `}
`

export const VerticalSeparator = styled.div`
  width: 0.125rem;
  margin: 0 1.35rem;
  background: ${({ theme }) =>
    theme.component.isDarkBackground ? theme.colors.text.primary : "#fff"};
`

export const IconContainer = styled.div`
  margin-left: 1rem;
`

export const RightArrow = styled.span`
  width: 0;
  height: 0;
  margin: 0 0 0.1rem 0.8rem;
  border-style: solid;
  border-width: 0.5rem 0 0.5rem 0.7rem;
  border-color: transparent transparent transparent #fff;

  ${({ theme }) =>
    theme.component.isDarkBackground &&
    `border-color: transparent transparent transparent ${theme.colors.text.primary};`}

  ${maxWidth.mobile`
    display: none;
  `}
`

export const AffirmContainer = styled.div`
  height: 6rem;

  .affirm-modal-trigger {
    text-decoration: underline;
    color: #00a3b7;
  }

  .affirm-as-low-as {
    text-align: center;
    font-size: 1.8rem;
  }

  .__affirm-logo.__affirm-logo-blue {
    color: ${({ theme }) =>
      theme.component.isDarkBackground ? "#fff" : theme.colors.text.primary};
  }
`
